import logger from 'saddlebag-logger';

import type { Place } from '@skyscanner-internal/global-components/packages-search-controls/types/place';

type PackagesUrlParams = {
  adults: number;
  childrenAges: number[];
  origin?: Place;
  destination?: Place;
  outboundDate?: string;
  inboundDate?: string;
  source: string;
};

const getPackagesDayviewUrl = ({
  adults,
  childrenAges,
  destination,
  inboundDate,
  origin,
  outboundDate,
  source,
}: PackagesUrlParams): string => {
  const baseUrl = `/package-holidays`;

  // Ensure all required path parameters are present
  if (destination && origin && outboundDate && inboundDate) {
    const originEntityId = origin.entityId;
    const destinationEntityId = destination.entityId;

    if (!originEntityId || !destinationEntityId) {
      // Log warning when entityIds are missing
      logger.logWarn({
        message: 'Packages search controls missing entityId',
        component: 'packages-search-controls-gc-wrapper',
        hasOrigin: origin ? 1 : 0,
        hasDestination: destination ? 1 : 0,
        originEntityId: originEntityId || 'missing',
        destinationEntityId: destinationEntityId || 'missing',
        originPlaceName: origin?.placeName || 'unknown',
        destinationPlaceName: destination?.placeName || 'unknown',
        source,
      });

      // Return base URL as safe fallback - user will land on packages homepage
      return baseUrl;
    }

    const childrenParam =
      childrenAges.length > 0
        ? `&childrenv2=${childrenAges.map((age) => encodeURIComponent(age.toString())).join('%2C')}`
        : '';

    return `${baseUrl}/${encodeURIComponent(originEntityId)}/${encodeURIComponent(destinationEntityId)}/${encodeURIComponent(outboundDate)}/${encodeURIComponent(inboundDate)}?adultsv2=${encodeURIComponent(adults.toString())}${childrenParam}&source=${encodeURIComponent(source)}`;
  }

  return baseUrl;
};

export default getPackagesDayviewUrl;
